import * as React from 'react';
import { useXyqarAuth } from '@xyqar/shared-auth';
import { apiGet, apiPost } from '../lib/api';
import { PageTitle, Card, Btn } from '../components/ui-kit';

export default function Profile() {
  const { getToken } = useXyqarAuth();
  const [p, setP] = React.useState<any>(null);
  const [msg, setMsg] = React.useState<string | null>(null);

  React.useEffect(() => {
    (async () => {
      try { const tok = await getToken().catch(() => ''); setP(await apiGet('/api/v1/expert/profile', tok)); }
      catch { setP({}); }
    })();
  }, [getToken]);

  const save = async () => {
    setMsg(null);
    try {
      const tok = await getToken().catch(() => '');
      await apiPost('/api/v1/expert/profile', p, tok);
      setMsg('Saved.');
    } catch (e: any) { setMsg(`Error: ${e.message}`); }
  };

  if (!p) return <Card>Loading…</Card>;
  const inp = 'w-full rounded-md bg-white/5 border border-white/10 px-4 py-3 text-sm text-white focus:outline-none focus:border-white/40';

  return (
    <div>
      <PageTitle kicker="Identity" title="Public profile" />
      <Card>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field label="Display name"><input className={inp} value={p.display_name ?? ''} onChange={(e) => setP({ ...p, display_name: e.target.value })} /></Field>
          <Field label="Tagline"><input className={inp} value={p.tagline ?? ''} onChange={(e) => setP({ ...p, tagline: e.target.value })} /></Field>
          <Field label="Day rate (EUR)"><input type="number" className={inp} value={p.day_rate ?? ''} onChange={(e) => setP({ ...p, day_rate: Number(e.target.value) })} /></Field>
          <Field label="Availability"><input className={inp} value={p.availability ?? ''} onChange={(e) => setP({ ...p, availability: e.target.value })} /></Field>
          <Field label="Bio (markdown)" wide>
            <textarea rows={6} className={inp} value={p.bio ?? ''} onChange={(e) => setP({ ...p, bio: e.target.value })} />
          </Field>
        </div>
        {msg && <p className="text-xs text-white/60 mt-4">{msg}</p>}
        <div className="flex justify-end mt-6"><Btn primary onClick={save}>Save</Btn></div>
      </Card>
    </div>
  );
}
function Field({ label, children, wide }: { label: string; children: React.ReactNode; wide?: boolean }) {
  return (
    <label className={`flex flex-col gap-2 ${wide ? 'sm:col-span-2' : ''}`}>
      <span className="text-xs uppercase tracking-wider text-white/60">{label}</span>
      {children}
    </label>
  );
}
